import React from "react";
import { cn } from "@/lib/utils";

/**
 * One band of Home below the search: a section title (h2, Figtree), an
 * optional one-line note under it and an optional action at its end, then
 * the content. Every band shares the page's one container and gutters
 * (16 / 24 / 32 px), so the titles line up with the logo and the search card.
 *
 * The title takes focus when the band before it disappears (clearing the
 * recent searches), so a keyboard or screen-reader visitor is not dropped at
 * the top of the page.
 */
export default function HomeSection({ id, title, note, action, className, children, "data-testid": testId }) {
  const headingId = `home-${id}-title`;
  return (
    <section aria-labelledby={headingId} data-home-section={id} data-testid={testId}
      className={cn("mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8", className)}>
      <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-2">
        <div className="min-w-0 max-w-[65ch]">
          <h2 id={headingId} tabIndex={-1} className="scroll-mt-24 text-heading-lg text-touki-black focus:outline-none">{title}</h2>
          {note ? <p className="mt-1 text-body-sm text-touki-muted text-pretty">{note}</p> : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
      <div className="mt-4 sm:mt-5">{children}</div>
    </section>
  );
}
